import { getFireTablet, isTabletUserAgent } from './tabletDetection';

function detectTablet(ua) {
  return isTabletUserAgent(ua) ? 'tablet' : 'smartphone';
}

// eslint-disable-next-line max-statements
function detectPlatform() {
  const platform = window.navigator.platform;
  const ua = window.navigator.userAgent; // window.navigator.userAgent || window.navigator.vendor || window.opera;
  const device = { type: 'unknown', os: 'unknown', family: 'unknown', version: 'unknown' };
  if (!window.MSStream) {
    const iphone = ua.match(/iPhone|iPod/);
    const ipad = ua.match(/iPad/);
    const ipadOS13 = platform === 'MacIntel' && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;

    if (iphone || ipad || ipadOS13) {
      const version = navigator.userAgent.match(/Version\/(\d+)\.(\d+)\.?(\d+)?/);
      const major = version && version[1] ? version[1] : '';
      const minor = version && version[2] ? version[2] : '';
      const patch = version && version[3] ? version[3] : '';

      device.os = 'ios';
      device.family = 'ios';
      device.type = iphone ? 'smartphone' : 'tablet';
      device.majorVersion = !isNaN(parseInt(major)) ? parseInt(major) : 0;
      device.version = `${major}.${minor}.${patch}`;
      return device;
    }
  }

  const fireTablet = getFireTablet(ua);
  if (fireTablet) {
    device.type = 'tablet';
    device.os = 'fire';
    device.family = 'android';
    device.kindle = fireTablet;
    return device;
  }

  const android = ua.match(/(Android)\s+([\d.]+)/);
  if (android) {
    device.type = detectTablet(ua);
    device.os = 'android';
    device.family = 'android';
    device.version = android[2];
    return device;
  }

  const webos = ua.match(/webOS|hpwOS/);
  if (webos) {
    device.type = detectTablet(ua);
    device.os = 'webos';
    device.family = 'webos';
    return device;
  }
  const blackberry = ua.match(
    /BlackBerry|\\bBB10\\b|rim[0-9]+|\\b(BBA100|BBB100|BBD100|BBE100|BBF100|STH100)\\b-[0-9]+/
  );
  if (blackberry) {
    device.type = detectTablet(ua);
    device.os = 'blackberry';
    device.family = 'blackberry';
    return device;
  }

  const windowsMobileOS = ua.match(
    /Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Windows Mobile|Windows Phone [0-9.]+|WCE/
  );
  const WindowsPhoneOS = ua.match(
    /Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM/
  );
  if (windowsMobileOS || WindowsPhoneOS) {
    device.type = 'smartphone';
    device.os = 'windows';
    device.family = 'windows';
    return device;
  }

  const windows = ua.match(/windows/i);
  const macintosh = ua.match(/macintosh/i);
  const cros = ua.match(/cros/i); // linux
  const desktop = windows || macintosh || cros;
  if (desktop) {
    device.type = 'desktop';
    device.os = windows ? 'windows' : macintosh ? 'macintosh' : cros ? 'linux' : 'unknown';
    return device;
  }

  return device;
}

/**
 * Get estimated platform game is running on
 * @returns detected platform
 */
export const getPlatform = () => {
  return detectPlatform();
};
